<template>
  <Select v-model="model" clearable @on-change="onChange" filterable>
    <Option v-for="item in activityList" :value="item.id" :key="item.id">{{ item.id + ' - ' + item.nickname }}</Option>
  </Select>
</template>
<script>
  export default {
    name: 'SalesAdviserSelect',
    props: {
        value: {
            type: [Number, String],
        }
    },
    data () {
      return {
        activityList: [],
        model: ''
      }
    },
    methods: {
      onChange (value) {
        this.$emit('input', value)
      },
    },
    mounted: function () {
      let self = this
      self.$http.get('userstatusreview/queryalladminuser').then(function (res) {
        if (res && res.data) {
          self.activityList = res.data
        } else {
          self.activityList = []
        }
      })
    },
    watch: {
      value (val) {
        if (val) {
          let idNumber = parseInt(val)
          this.model = idNumber
        } else {
          this.model = null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SalesAdviserSelect.vue?4973188e